import script from "./AnnouncementPreviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementPreviewModal.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementPreviewModal.vue?vue&type=style&index=0&id=0da369e4&scoped=true&lang=scss"
script.__scopeId = "data-v-0da369e4"

export default script